import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDocTransmittalContext } from "../DocTransmittal.context";
import { getCompanyCustomers, getCompanyVendors } from "../api";
import { ListItemText, Typography } from "@mui/material";

export default function ReceiverForm() {
  const { newDoc, setNewDoc } = useDocTransmittalContext();

  const [receivers, setReceivers] = React.useState([]);

  React.useEffect(() => {
    const getReceivers = async () => {
      if (newDoc.receiverType === "Client") {
        const res = await getCompanyCustomers();
        setReceivers(res);
      } else {
        const res = await getCompanyVendors();
        setReceivers(res);
      }
    };

    getReceivers();
  }, [newDoc.receiverType]);

  const onChange = (e) => {
    setNewDoc({
      ...newDoc,
      receiver: receivers.find((r) => r.id === e.target.value),
    });
  };

  const value =
    newDoc?.vendor?.id || newDoc?.customer?.id || newDoc.receiver?.id;
  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Box sx={{ maxWidth: 700, minWidth: 480 }}>
        <FormControl disabled fullWidth>
          <InputLabel>{newDoc.receiverType}</InputLabel>
          <Select value={value} label={newDoc.receiverType} onChange={onChange}>
            {receivers.map((r) => {
              return (
                <MenuItem value={r.id} key={r.id}>
                  {/* <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon> */}
                  <ListItemText>{r.name}</ListItemText>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {r.email}
                  </Typography>
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
      {/* 
      <Button sx={{ flexGrow: 1 }} variant="outlined">
        Send To New {newDoc.receiverType}
      </Button> */}
    </Box>
  );
}
